export class MessageReader
{
  private readonly view: DataView;
  private readonly decoder = new TextDecoder();
  private body: unknown;

  constructor( private readonly buffer: ArrayBuffer )
  {
    this.view = new DataView( buffer );
  }

  public readCommand(): number
  {
    return this.view.getUint16( 0, true );
  }

  public readBodyLength(): number
  {
    return this.view.getUint16( 2, true );
  }

  public getBufferLength(): number
  {
    return this.view.byteLength;
  }

  public readBody(): void
  {
    const body_bytes = new Uint8Array( this.buffer.slice( 4, 4 + this.readBodyLength() ) );
    const body_text = this.decoder.decode( body_bytes );

    try
    {
      const parsed: unknown = JSON.parse( body_text );
      this.body = parsed && typeof parsed === 'object' && 'payload' in parsed
        ? ( parsed as { payload: unknown } ).payload
        : parsed;
    }
    catch
    {
      this.body = body_text;
    }
  }

  public getBodyElement<T>( key: string ): T | undefined
  {
    if ( this.body && typeof this.body === 'object' && key in this.body )
      return ( this.body as Record<string, unknown> )[key] as T;
    return undefined;
  }
}
